import React, { useEffect, useMemo } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory, {
  PaginationProvider,
} from 'react-bootstrap-table2-paginator';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import {
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  sortCaret,
  headerSortingClasses,
} from '../../../../../../_metronic/_helpers';
import { injectIntl } from 'react-intl';
import { Pagination } from '../../../../../../_metronic/_partials/controls';
import * as uiHelpers from './../BoxesUIHelpers';
import * as columnFormatters from './column-formatters';
import { useBoxesUIContext } from './../BoxesUIContext';
import * as actions from '../../../_redux/boxes/boxesActions';

const BoxesTable = (props) => {
  const { intl } = props;
  const orderDateLabel = intl.formatMessage({ id: 'ORDER.LABEL.ORDERDATE' });
  const trackingIdLabel = intl.formatMessage({ id: 'BOX.LABEL.TRACKINGID' });
  const weightLabel = intl.formatMessage({ id: 'BOX.LABEL.WEIGHT' });
  const websiteLabel = intl.formatMessage({ id: 'ORDER.LABEL.WEBSITE' });
  const totalCostLabel = intl.formatMessage({ id: 'ORDER.LABEL.TOTALCOST' });
  const receivedLabel = intl.formatMessage({
    id: 'BOX.LABEL.RECEIVEDDATE',
  });
  const statusLabel = intl.formatMessage({
    id: 'BOX.LABEL.BOXSTATUS',
  });
  const cargoLabel = intl.formatMessage({
    id: 'BOX.LABEL.CARGOREGISTERED',
  });
  const actionsLabel = intl.formatMessage({ id: 'BOX.LABEL.ACTIONS' });

  // Boxes UI Context
  const BoxesUIContext = useBoxesUIContext();
  const BoxesUIProps = useMemo(() => {
    return {
      queryParams: BoxesUIContext.queryParams,
      setQueryParams: BoxesUIContext.setQueryParams,
      openViewBoxDialog: BoxesUIContext.openViewBoxDialog,
    };
  }, [BoxesUIContext]);

  // Getting curret state of Boxes list from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.boxes }),
    shallowEqual
  );
  const { totalCount, entities, listLoading } = currentState
    ? currentState
    : { totalCount: 0, entities: [], listLoading: false };

  // Boxes Redux state
  const dispatch = useDispatch();
  useEffect(() => {
    // server call by queryParams
    dispatch(actions.fetchBoxes(BoxesUIProps.queryParams));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [BoxesUIProps.queryParams, dispatch]);

  // Table columns

  const columns = [
    /*     {
      dataField: 'check',
      text: cargoLabel,
      sort: false,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: columnFormatters.CheckColumnFormatter,
    }, */
    {
      dataField: 'trackingId',
      text: trackingIdLabel,
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      dataField: 'websiteCode',
      text: websiteLabel,
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      dataField: 'orderDate',
      text: orderDateLabel,
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: columnFormatters.DateColumnFormatter,
    },

    {
      dataField: 'weight',
      text: weightLabel,
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,

      classes: 'text-right pr-2',
      style: {
        minWidth: '60px',
      },
    },
    {
      dataField: 'totalCost',
      text: totalCostLabel,
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: columnFormatters.PriceColumnFormatter,

      classes: 'text-right pr-1',
      style: {
        minWidth: '100px',
      },
    },
    {
      dataField: 'receivedDate',
      text: receivedLabel,
      sort: true,
      sortCaret: sortCaret,
      formatter: columnFormatters.DateColumnFormatter,
    },
    {
      dataField: 'boxStatus',
      text: statusLabel,
      sort: true,
      sortCaret: sortCaret,
      formatter: columnFormatters.StatusColumnFormatter,
    },
    {
      dataField: 'action',
      text: actionsLabel,
      formatter: columnFormatters.ActionsColumnFormatter,
      formatExtraData: {
        openViewBoxDialog: BoxesUIProps.openViewBoxDialog,
      },
      classes: 'text-right pr-0',
      headerClasses: 'text-right pr-3',
      style: {
        minWidth: '100px',
      },
    },
  ];
  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: BoxesUIProps.queryParams.pageSize,
    page: BoxesUIProps.queryParams.pageNumber,
  };
  return (
    <>
      <PaginationProvider pagination={paginationFactory(paginationOptions)}>
        {({ paginationProps, paginationTableProps }) => {
          return (
            <Pagination
              isLoading={listLoading}
              paginationProps={paginationProps}
            >
              <BootstrapTable
                wrapperClasses='table-responsive'
                bboxed={false}
                classes='table table-head-custom table-vertical-center overflow-hidden'
                bootstrap4
                remote
                keyField='id'
                data={entities === null ? [] : entities}
                columns={columns}
                defaultSorted={uiHelpers.defaultSorted}
                onTableChange={getHandlerTableChange(
                  BoxesUIProps.setQueryParams
                )}
                useSortBy
                {...paginationTableProps}
              >
                <PleaseWaitMessage entities={entities} />
                <NoRecordsFoundMessage entities={entities} />
              </BootstrapTable>
            </Pagination>
          );
        }}
      </PaginationProvider>
    </>
  );
};

export default injectIntl(BoxesTable);
